"use client";

import Link from "next/link";
import { ArrowLeft, Home, MessageSquare } from "lucide-react";
import { routes } from "@/lib/routes";

/**
 * Custom 404 page
 * Shown when a page is not found
 */
export default function NotFound() {
  return (
    <div className="flex min-h-[80vh] flex-col items-center justify-center px-4 text-center">
      <div className="space-y-6">
        {/* Error code */}
        <h1 className="text-8xl font-bold text-gray-200">404</h1>

        {/* Optimization info box */}
        <div className="bg-sky-50 border border-sky-200 rounded-lg p-4 max-w-lg mx-auto">
          <p className="text-sky-800 text-sm">
            Unsere neue oekopunktemarkt.de wird gerade optimiert. Dabei kann es zu Störungen kommen.
          </p>
          <p className="text-sky-700 text-sm mt-2">
            Bei Fragen erreichen Sie uns unter{" "}
            <a
              href="mailto:info@oekopunktemarkt.de"
              className="underline hover:no-underline font-medium"
            >
              info@oekopunktemarkt.de
            </a>{" "}
            oder über unser Kontaktformular.
          </p>
          <Link
            href={routes.content.kontakt}
            className="inline-flex items-center justify-center mt-3 px-4 py-2 bg-sky-500 text-white text-sm font-medium rounded-lg hover:bg-sky-600 transition-colors"
          >
            <MessageSquare className="mr-2 h-4 w-4" />
            Zum Kontaktformular
          </Link>
        </div>

        {/* Title and description */}
        <div className="space-y-2">
          <h2 className="text-2xl font-semibold text-gray-900">Seite nicht gefunden</h2>
          <p className="text-gray-600 max-w-md mx-auto">
            Die gesuchte Seite existiert nicht oder wurde verschoben. Probieren Sie eine der
            folgenden Optionen:
          </p>
        </div>

        {/* Action buttons */}
        <div className="flex flex-col sm:flex-row gap-3 justify-center pt-4">
          <Link
            href={routes.home}
            className="inline-flex items-center justify-center px-6 py-3 bg-primary text-white font-medium rounded-lg hover:bg-primary/90 transition-colors"
          >
            <Home className="mr-2 h-4 w-4" />
            Zur Startseite
          </Link>
        </div>

        {/* Recovery link for guest users */}
        <div className="pt-4">
          <Link
            href={routes.accessRecovery}
            className="inline-flex items-center text-sm text-gray-500 hover:text-gray-700 transition-colors font-medium"
          >
            Zugang zu einer Anfrage oder einem Angebot wiederherstellen
          </Link>
        </div>

        {/* Back link */}
        <div className="pt-4">
          <button
            onClick={() => window.history.back()}
            className="inline-flex items-center text-sm text-gray-500 hover:text-gray-700 transition-colors"
          >
            <ArrowLeft className="mr-2 h-4 w-4" />
            Zurück zur vorherigen Seite
          </button>
        </div>
      </div>
    </div>
  );
}
